const directlyEditableCorrectionTypes = ['REPAIR', 'REPLACE', 'ADJUST', 'PM'];

const toUpperString = value => {
    return value == null ? '' : String(value).toUpperCase();
};

const getLineItemValue = (lineItem, key) => {
    if (!lineItem) {
        return undefined;
    }

    if (typeof lineItem.get === 'function') {
        return lineItem.get(key);
    }

    return lineItem[key];
};

const shouldEditLineItemDirectly = (lineItem, actionType) => {
    return toUpperString(actionType) === 'DEALERDRAFT'
        || directlyEditableCorrectionTypes.includes(toUpperString(getLineItemValue(lineItem, 'correctionType')));
};

const hasRepairTypeChangeHandler = onChangeRepairTypeClick => {
    return typeof onChangeRepairTypeClick === 'function';
};

const getLineItemEditAction = (lineItem, actionType, onChangeRepairTypeClick) => {
    if (!lineItem) {
        return 'disabled';
    }

    if (shouldEditLineItemDirectly(lineItem, actionType)) {
        return 'edit';
    }

    return hasRepairTypeChangeHandler(onChangeRepairTypeClick) ? 'repairType' : 'disabled';
};

const getLineItemEditControl = (lineItem, actionType, onChangeRepairTypeClick) => {
    if (getLineItemEditAction(lineItem, actionType, onChangeRepairTypeClick) === 'disabled') {
        return 'none';
    }

    return getLineItemValue(lineItem, 'isBeingEdited') === true ? 'update' : 'edit';
};

const runLineItemEditAction = ({
    actionType,
    complaintCode,
    lineItem,
    lineItemKey,
    onChangeRepairTypeClick,
    onEditLineItemClick,
    quantity,
    setQuantity,
    setUnitPrice,
    unitPrice
}) => {
    const editAction = getLineItemEditAction(lineItem, actionType, onChangeRepairTypeClick);

    if (editAction === 'repairType') {
        onChangeRepairTypeClick(lineItemKey, complaintCode);
        return editAction;
    }

    if (editAction === 'edit' && typeof onEditLineItemClick === 'function') {
        onEditLineItemClick(lineItemKey);

        if (typeof setQuantity === 'function') {
            setQuantity(quantity);
        }

        if (typeof setUnitPrice === 'function') {
            setUnitPrice(unitPrice);
        }
    }

    return editAction;
};

module.exports = {
    getLineItemEditAction,
    getLineItemEditControl,
    hasRepairTypeChangeHandler,
    runLineItemEditAction,
    shouldEditLineItemDirectly
};
